import $ from 'jquery';


$('.fakebtnsearch').on('click',function(){
    $(this).hide();
    $('.header__searchbox').addClass('active');
});
if ($(window).width() > 920) {
    setTimeout(function(){
        let minheightbox = $('.ew__boxeslow').height();
        minheightbox = minheightbox-20;
        $('.ew__box--big').css('min-height',minheightbox);
    }, 2000);
 }

 export default class Header {
    constructor(e, p) {
        this.$e = $(e);
        this.$p = $(p);
        if (this.$e.length && this.$p.length) this.init();
    }

    init() {
        $(window).on('scroll', () => {
            let scroll = window.scrollY;
            
            if (scroll > 2) { 
                // scroll = this.$p.height();
                this.$e.addClass('fixed-header');
            }else{
                this.$e.removeClass('fixed-header');
            }
            // this.$e.css('margin-top', scroll * -1 + 'px');
        });
        $(window).trigger('scroll');
        $('.ham').on('click', () => {
            $('.ham, .header__left > ul').toggleClass('active');
            if ($('.ham').hasClass('active')) {
                // this.$e.css('margin-top', this.$p.height() * -1 + 'px');
            } else {
                $(window).trigger('scroll');
            }
        });
        $('.ham').on('click', () => {
           
            $('.header__mobile-menu').toggleClass('active');
          });
        // $('.menu-parent-1 > li > a').hover(function () {
        //     const $t = $(this);
        //     const $n = $t.next();
        //     $n.css('height', $n[0].scrollHeight + 'px');
        // }, function () {
        //     $(this).next().removeAttr('style');
        // });
        $('.menu-parent-1 > li.menu-item-has-children > a').each((i, e) => {
            const $e = $(e);
           
            $e.on('click', (x) => {
                
                if ($(window).width() > 920) return;
                if (!$e.hasClass('allowClick')) {
                    x.preventDefault();
                    $('.menu-parent-1 > li.menu-item-has-children > a').removeClass('allowClick');
                    $('.menu-parent-1 > li.menu-item-has-children > a').next().removeAttr('style');
                    
                    $e.next().addClass('active');
                    const $n = $e.next();
                    $n.css('height', $n[0].scrollHeight + 'px');
                    $e.addClass('allowClick');
                }
            })
        });
        $('.menu-parent-2 > li.menu-item-has-children > a').each((i, e) => {
            const $e = $(e);
            if ($(window).width() > 920) return;
            $e.on('click', (x) => {
                console.log("22222222222");
                if (!$e.hasClass('allowClick')) {
                    x.preventDefault();
                    $('.menu-parent-2 > li.menu-item-has-children > a').removeClass('allowClick');
                    $('.menu-parent-2 > li.menu-item-has-children > a').next().removeAttr('style');
                    const $n = $e.next();
                    // $n.css('height', $n[0].scrollHeight + 'px');
                    $e.next().addClass('active');
                    $e.addClass('allowClick');
                    if ($(window).width() <= 920) {
                        setTimeout(() => {
                            let height = 0;
                            $e.parent().parent().children().each((i, e) => {
                                height += $(e).height() + 8;
                            });
                            // height = Math.min(height, $e.parent().parent()[0].scrollHeight);
                            $e.parent().parent().css('height', height + 'px');
                        }, 200);
                    }
                }
            })
        });
        $('.menu-parent-3 > li.menu-item-has-children > a').each((i, e) => {
            const $e = $(e);
            if ($(window).width() > 920) return;
            $e.on('click', (x) => {
                
                if (!$e.hasClass('allowClick')) {
                    x.preventDefault();
                    $('.menu-parent-3 > li.menu-item-has-children > a').removeClass('allowClick');
                    $('.menu-parent-3 > li.menu-item-has-children > a').next().removeAttr('style');
                    const $n = $e.next();
                    // $n.css('height', $n[0].scrollHeight + 'px');
                    // $('.menu-parent-3').removeClass('active');
                    $e.next().addClass('active');
                    $e.addClass('allowClick');
                    if ($(window).width() <= 920) {
                        
                        console.log("333333333333333333");
                        setTimeout(() => {
                            let height = 0;
                            $e.parent().parent().children().each((i, e) => {
                                height += $(e).height() + 8;
                            });
                            // height = Math.min(height, $e.parent().parent()[0].scrollHeight);
                            $e.parent().parent().css('height', height + 'px');
                        }, 200);
                        setTimeout(() => {
                            let height = 0;
                            let height2 = 0;
                            let height3 = 0;
                            let height4 = 0;
                            console.log($e);
                            // height2 += $e.parent().height() + 8;
                            console.log(height2);
                            $e.parent().each((i, e) => {
                                height2 += $(e).height() + 8;
                            });
                            $e.parent().parent().parent().children().each((i, e) => {
                                height3 += $(e).height() + 8;
                            });
                            height4 = height2 + height3;
                            // height = Math.min(height, $e.parent().parent()[0].scrollHeight);
                            $e.closest('.menu-parent-2').css('height', height4 - 100 + 'px');
                            
                        }, 200);
                    }
                }
            })
        });
        const offsetMenu = () => {
            const offer = $('.menu-parent-1 > li:first-of-type .menu-parent-2');
            if ($(window).width() < 920) {
                offer.removeAttr('style');
            } else {
                // offer.css('margin-left', Math.min((offer.width() + offer[0].offsetLeft - $(window).width()) * -1, 0) + 'px');
            }
        };
        $(window).on('resize', () => {
            offsetMenu();
            $('.menu-parent-2 > li.menu-item-has-children > a').removeClass('allowClick');
            $('.menu-parent-2 > li.menu-item-has-children > a').next().removeAttr('style');
            $('.menu-parent-3 > li.menu-item-has-children > a').removeClass('allowClick');
            $('.menu-parent-3 > li.menu-item-has-children > a').next().removeAttr('style');
            $('.menu-parent-4 > li.menu-item-has-children > a').removeClass('allowClick');
            $('.menu-parent-4 > li.menu-item-has-children > a').next().removeAttr('style');
        });
        $(window).trigger('resize'); 
        $('.menu-parent-1 [href="#"]').removeAttr('href');
       
    }
} 
